import type { ComponentProps } from 'react'
import dynamic from 'next/dynamic'

import Experiment from '@mc/experiments-react'

const CMIncludedWithMasterClassBanner = dynamic(() =>
  import('./IncludedBanner').then((mod) => mod.CMIncludedWithMasterClassBanner),
)

// https://app.growthbook.io/features/pen-5301_v1
const CM_INCLUDED_W_MC_FLAG = 'pen-5301_v1'

export const CMIncludedWithMasterClassExperiment = (
  props: ComponentProps<typeof CMIncludedWithMasterClassBanner>,
) => (
  <Experiment
    name={CM_INCLUDED_W_MC_FLAG}
    control={() => null}
    variant_1={() => <CMIncludedWithMasterClassBanner {...props} />}
  />
)
